import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { NavbarComponent } from './navbar/navbar.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardScoreboardComponent } from './dashboard-scoreboard/dashboard-scoreboard.component';
import { ModulePageComponent } from './module-page/module-page.component';
import { LoginComponent } from './login/login.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { SearchResultsComponent } from './search-results/search-results.component';
import { ShareModule } from 'ng2share/share.module';
import { DataService } from './data.service';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RatingModule } from "ngx-rating";
import { SignUpStepsComponent } from './sign-up-steps/sign-up-steps.component';
import { AllModulesComponent } from './all-modules/all-modules.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  SocialLoginModule,
  AuthServiceConfig,
  GoogleLoginProvider,
  FacebookLoginProvider,
  LinkedinLoginProvider
} from 'ng4-social-login';
import { ModulesByThemeComponent } from './modules-by-theme/modules-by-theme.component';
import {GoalTime} from './module-page/goal-time';
import { TeamComponent } from './team/team.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { Page404Component } from './page-404/page-404.component';
import { OfflineComponent } from './offline/offline.component';
import { FaqComponent } from './faq/faq.component';
import { BadgesComponent } from './badges/badges.component';
// import { MyDatePickerModule } from 'angular4-datepicker/src/my-date-picker/my-date-picker.module';
import { EnterpriseComponent } from './enterprise/enterprise.component';
import { PricingComponent } from './pricing/pricing.component';
import { ProfileComponent } from './profile/profile.component';
import { SubscriptionDetailsComponent } from './subscription-details/subscription-details.component';
import { MyDatePipe, CalDiscount } from './my-date.pipe';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { SitemapComponent } from './sitemap/sitemap.component';
import { AppDatePickerDirective } from './app-date-picker.directive';
import { FooterIconsComponent } from './footer-icons/footer-icons.component';
import { ThankYouComponent } from './thank-you/thank-you.component';
import { LandingModulesComponent } from './landing-modules/landing-modules.component';

const CONFIG = new AuthServiceConfig([
  {
    id: GoogleLoginProvider.PROVIDER_ID,
    provider: new GoogleLoginProvider('840597955605-8h3d3v7uf839irnqf7fu7qcsq0l2u5lf.apps.googleusercontent.com')
  },
  {
    id: FacebookLoginProvider.PROVIDER_ID,
    provider: new FacebookLoginProvider('312985522562562')
  },
  {
    id: LinkedinLoginProvider.PROVIDER_ID,
    provider: new LinkedinLoginProvider('86h4865hj8zo0r')
  }
]);

export function provideConfig() {
  return CONFIG;
}


@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    FooterComponent,
    HomeComponent,
    DashboardComponent,
    DashboardScoreboardComponent,
    ModulePageComponent,
    LoginComponent,
    SignUpComponent,
    SearchResultsComponent,
    SignUpStepsComponent,
    AllModulesComponent,
    ModulesByThemeComponent,
    GoalTime,
    TeamComponent,
    ContactUsComponent,
    PrivacyPolicyComponent,
    Page404Component,
    OfflineComponent,
    FaqComponent,
    BadgesComponent,
    EnterpriseComponent,
    PricingComponent,
    ProfileComponent,
    SubscriptionDetailsComponent,
    MyDatePipe,
    CalDiscount,
    ChangePasswordComponent,
    SitemapComponent,
    AppDatePickerDirective,
    FooterIconsComponent,
    ThankYouComponent,
    LandingModulesComponent


  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    HttpModule,
    ShareModule,
    FormsModule,ReactiveFormsModule,RatingModule, SocialLoginModule,
    RouterModule.forRoot([

      { path: '', component:HomeComponent, pathMatch: 'full' },
      { path:'sharing/:id', component: HomeComponent},
      { path:'dashboard', component: DashboardComponent},
      { path:'scoreboard', component: DashboardScoreboardComponent},
      { path:'module/:name/:id', component: ModulePageComponent},
      { path:'login', component: LoginComponent},     
      { path:'sign-up', component: SignUpComponent},
      { path:'search-results/:searched',component:SearchResultsComponent},
      { path:'sign-up-steps', component:SignUpStepsComponent },
      { path:'all-modules/:type',component:AllModulesComponent},
      { path:'landing-modules',component:LandingModulesComponent},
      { path:'module-by-theme/:name/:id',component:ModulesByThemeComponent},
      { path:'team',component:TeamComponent},
      { path:'contact-us',component:ContactUsComponent},
      { path:'privacy-policy',component:PrivacyPolicyComponent},
      { path:'offline',component:OfflineComponent},
      { path:'faq' , component:FaqComponent},
      { path:'enterprise',component:EnterpriseComponent},
      // { path:'pricing',component:PricingComponent},
      { path:'pricing-25',component:PricingComponent},
      { path:'pricing-40',component:PricingComponent},
      { path:'edit-profile/:id',component: ProfileComponent},
      { path:'subscription-details/:id',component: SubscriptionDetailsComponent},
      { path:'change-password',component:ChangePasswordComponent},
      { path:'sitemap',component:SitemapComponent},
      { path:'thanks',component:ThankYouComponent},
      { path: '**', component:Page404Component},

      // { path: 'app-module-page', component: ModulePageComponent },
      // { path: 'app-dashboard', component: DashboardComponent }
    ], {
      useHash: false
    })

  ],
  providers: [MyDatePipe,DataService,LoginComponent,HomeComponent,NavbarComponent ,FooterComponent,ModulePageComponent,
    {
      provide: AuthServiceConfig,
      useFactory: provideConfig
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/app.module.ts